module.exports = __webpack_public_path__ + "static/media/metafest-rocks.abb961b0.gif";